@let _userDTO = userDTO();
<nz-row [nzGutter]="[0, 16]">
  <nz-col
    [nzLg]="{ span: 8, offset: 0 }"
    [nzMd]="{ span: 10, offset: 0 }"
    [nzSm]="{ span: 24, offset: 0 }"
    [nzXs]="{ span: 24, offset: 0 }"
    class="display-flex justify-content-center align-items-center">
    <nz-avatar
      (click)="onAvatarClick(_userDTO)"
      [class]="{ pointer: hasAvatar(_userDTO) }"
      [nzIcon]="'user'"
      [nzShape]="'circle'"
      [nzSize]="192"
      [nzSrc]="getThumbnailUrl(_userDTO)" />
  </nz-col>
  <nz-col
    [nzLg]="{ span: 16, offset: 0 }"
    [nzMd]="{ span: 14, offset: 0 }"
    [nzSm]="{ span: 24, offset: 0 }"
    [nzXs]="{ span: 24, offset: 0 }">
    <nz-row [nzGutter]="[0, 8]">
      <nz-col [nzSpan]="24">
        <h1 nz-typography>
          {{ _userDTO.username }}
          @if (_userDTO.verified) {
            <nz-icon
              nz-tooltip
              i18n-nzTooltipTitle="
                @@page-profile-content-info-verified-account-tooltip-title"
              nzTooltipTitle="Verified account"
              [nzTooltipPlacement]="'bottom'">
              <app-icon-verified [width]="32" [height]="32"></app-icon-verified>
            </nz-icon>
          }
        </h1>
      </nz-col>
      <nz-col [nzSpan]="24">
        <nz-row [nzGutter]="[24, 0]">
          <nz-col>
            <nz-statistic
              [nzValue]="(_userDTO.mediaCount | number)!"
              i18n-nzTitle="@@page-profile-content-info-posts-statistic-title"
              nzTitle="Posts" />
          </nz-col>
          <nz-col>
            <nz-statistic
              [nzValue]="(_userDTO.followerCount | number)!"
              i18n-nzTitle="
                @@page-profile-content-info-followers-statistic-title"
              nzTitle="Followers" />
          </nz-col>
          <nz-col>
            <nz-statistic
              [nzValue]="(_userDTO.followingCount | number)!"
              i18n-nzTitle="
                @@page-profile-content-info-following-statistic-title"
              nzTitle="Following" />
          </nz-col>
        </nz-row>
      </nz-col>
      @if (_userDTO.fullName) {
        <nz-col [nzSpan]="24">
          <span nz-typography
            ><strong>{{ _userDTO.fullName }}</strong></span
          >
        </nz-col>
      }
      @if (_userDTO.category) {
        <nz-col [nzSpan]="24">
          <span nz-typography [nzType]="'secondary'">{{
            _userDTO.category
          }}</span>
        </nz-col>
      }
      @if (userDTO().contact) {
        @let _contact = _userDTO.contact!;
        <nz-col [nzSpan]="24">
          <nz-row [nzGutter]="[8, 8]">
            @if (_contact.phoneNumber) {
              <nz-col>
                <span nz-typography>
                  <nz-icon [nzType]="'phone'" [nzTheme]="'outline'" />
                  {{ _contact.phoneNumber }}
                </span>
              </nz-col>
            }
            @if (_contact.website) {
              <nz-col>
                <span nz-typography>
                  <a [href]="_contact.website" [target]="'_blank'">
                    <nz-icon [nzType]="'global'" [nzTheme]="'outline'" />
                    {{ _contact.website }}
                  </a>
                </span>
              </nz-col>
            }
            @if (_contact.email) {
              <nz-col>
                <span nz-typography>
                  <nz-icon [nzType]="'mail'" [nzTheme]="'outline'" />
                  {{ _contact.email }}
                </span>
              </nz-col>
            }
          </nz-row>
        </nz-col>
      }
      @if (hasAddress(_userDTO)) {
        <nz-col [nzSpan]="24">
          <span nz-typography [nzType]="'secondary'">{{
            getAddress(_userDTO)
          }}</span>
        </nz-col>
      }
      @if (userDTO().biography) {
        @let _biography = _userDTO.biography!;
        @if (_biography.value) {
          <nz-col [nzSpan]="24">
            <span nz-typography class="biography">{{ _biography.value }}</span>
          </nz-col>
        }
        @if (_biography.users.length) {
          <nz-col [nzSpan]="24">
            <nz-row [nzGutter]="[0, 8]">
              @for (
                biographyUserDTO of _biography.users;
                track biographyUserDTO.primaryKey
              ) {
                <nz-col>
                  <nz-tag
                    [nzColor]="'#1f2ade'"
                    [nzBordered]="false"
                    (click)="onUserTagClick(biographyUserDTO.username)"
                    class="pointer">
                    &#64;{{ biographyUserDTO.username }}
                  </nz-tag>
                </nz-col>
              }
            </nz-row>
          </nz-col>
        }
        @if (_biography.links.length) {
          <nz-col [nzSpan]="24">
            <nz-row>
              @for (
                biographyLinkDTO of _biography.links;
                track biographyLinkDTO.primaryKey
              ) {
                <nz-col [nzSpan]="24">
                  <span nz-typography>
                    <a [href]="biographyLinkDTO.url" [target]="'_blank'">{{
                      biographyLinkDTO.title ?? biographyLinkDTO.url
                    }}</a>
                  </span>
                </nz-col>
              }
            </nz-row>
          </nz-col>
        }
      }
    </nz-row>
  </nz-col>
</nz-row>
